module.exports = __webpack_public_path__ + "img/ua.b7a1a3c0.svg";